module.exports = __webpack_public_path__ + "static/images/components/Back/images/close.92971416.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/close.png
// module id = 2493
// module chunks = 11